import * as React from 'react';
import * as queryString from 'query-string';

import { followUpOnlyTitle, fullApplicationTitle } from 'login-constants/titles';
import LeftPane, { LeftPaneProps } from '../../Common/PaneLayout/LeftPane/LeftPane';
import * as stateUtils from 'login-utils/stateUtils';

export default class BorrowerActivationLeftPane extends React.Component<
  ReactRouter.RouteComponentProps<{}, {}> & LeftPaneProps
> {
  render() {
    const { location, ...leftPaneProps } = this.props;
    const queryParams = stateUtils.getOptionalCreationParams(queryString.parse(location.search), ['isFollowUpOnly']);
    const isFollowUpOnly = queryParams.isFollowUpOnly;
    const title = isFollowUpOnly ? followUpOnlyTitle : fullApplicationTitle;

    return <LeftPane {...leftPaneProps} documentTitle="Activate" showBackButton={false} title={title} />;
  }
}
